import { CasChip, CasStackRow } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import InactiveChip from './InactiveChip';

interface IProps extends ICasRenderCellProps {
  onClick?: (id: number) => void;
}

export function RenderRiskManagerName({ row, column, onClick }: IProps) {
  const value = getCasTableCellValue({ row, column });
  const { otherRiskManagerNames, rmcOfRecordName, id, inactive } = row || {};
  return (
    <CasStackRow alignItems="center">
      {onClick ? <CasLink onClick={() => onClick(id)}>{value}</CasLink> : value}
      {inactive && <InactiveChip />}
      {/* Light yellow marks the customer's Service Owner. The RMC filter's own employee is never
          among these chips, so when they are the Service Owner no chip is yellow. */}
      {otherRiskManagerNames?.map((riskManager: string) => (
        <CasChip
          key={riskManager}
          label={riskManager}
          color={riskManager === rmcOfRecordName ? 'warning' : 'disabled'}
          size="small"
        />
      ))}
    </CasStackRow>
  );
}
